/**
 * Created by katarinababic on 8.5.25.
 */
import * as React from 'react';
import { observer } from 'mobx-react';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import styled from '@emotion/styled';
import { Button } from './Button';

const StyledModal = styled(Modal)`
  .modal-content {
    border-radius: 8px;
    max-width: 800px;
    width: 100%;
  }
`;

const StyledModalBody = styled(ModalBody)`
  padding: 32px 16px;
`;

const StyledModalFooter = styled(ModalFooter)`
  padding: 32px 16px;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 8px;
`;

export type AlertModalProps = {
  isOpen: boolean;
  title: string;
  body: React.ReactNode;
  confirmText?: string;
  cancelText?: string;
  onCancel: () => void;
  onConfirm: () => void;
  secondaryActionText?: string;
  onSecondaryAction?: () => void;
  secondaryActionColor?: string;
};

export const AlertModal: React.FC<AlertModalProps> = observer(
  ({
    isOpen,
    title,
    body,
    confirmText = 'Confirm',
    cancelText = 'Cancel',
    onCancel,
    onConfirm,
    secondaryActionText,
    onSecondaryAction,
    secondaryActionColor = 'danger',
  }) => {
    const modalRef = React.useRef(null);

    return (
      <StyledModal
        isOpen={isOpen}
        toggle={onCancel}
        centered
        size={'lg'}
        nodeRef={modalRef}
      >
        <div ref={modalRef}>
          <ModalHeader toggle={onCancel}>{title}</ModalHeader>
          <StyledModalBody>{body}</StyledModalBody>
          <StyledModalFooter>
            {secondaryActionText && onSecondaryAction ? (
              <React.Fragment>
                <Button color={secondaryActionColor} size="sm" onClick={onSecondaryAction}>
                  {secondaryActionText}
                </Button>
                <Button color="primary" size="sm" onClick={onConfirm}>
                  {confirmText}
                </Button>
                <Button color="secondary" size="sm" onClick={onCancel}>
                  {cancelText}
                </Button>
              </React.Fragment>
            ) : (
              <React.Fragment>
                <Button color="secondary" size="sm" onClick={onCancel}>
                  {cancelText}
                </Button>
                <Button color="primary" size="sm" onClick={onConfirm}>
                  {confirmText}
                </Button>
              </React.Fragment>
            )}
          </StyledModalFooter>
        </div>
      </StyledModal>
    );
  },
);
